import _ from 'lodash';
import { preload, goto } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import { fetchSelectPage } from 'app/api/onboarding-api';
import SelectMachine from 'app/components/setup/select-machine';
import features from 'app/common/containers/features';
import { setSelectedMode } from 'app/actions/onboarding';
import { COLOR_MODES } from 'app/app-constants';
import { getAssetsForPage } from 'app/common/selectors/page';

const { getStringsForPage } = contentfulModels;

const mapStateToProps = (state) => {
  const selectMachinePage = _.get(state, 'onboarding.selectMachinePage');
  return {
    title: selectMachinePage.title,
    pageStrings: getStringsForPage(selectMachinePage),
    assets: getAssetsForPage(selectMachinePage),
  };
};

const mapDispatchToProps = dispatch => ({
  onSelect: (mode) => {
    dispatch(setSelectedMode({ mode }));
    if (mode === COLOR_MODES.ORANGE) {
      dispatch(goto('/setup/instructions'));
    } else {
      dispatch(goto('/setup/unboxing'));
    }
  },
});

const preloadContent = ({ dispatch }) =>
  Promise.all([
    dispatch(fetchSelectPage()),
  ]);

const SelectMachineContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(preload(preloadContent)(SelectMachine));

export default features(SelectMachineContainer);



// WEBPACK FOOTER //
// ./app/containers/setup/select-machine.js